import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import './App.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import Welcome from './components/Welcome';
import DataCapture from './components/DataCapture';
import { UserProvider } from './components/UserContext';
import ImageCapture from './components/ImageCapture';

function App() {
  return (
    <BrowserRouter>
      <UserProvider>
        <Routes> 
          <Route path="*" element={<Login />} />   
          <Route path="/login" element={<Login />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/" element={<Welcome />} />
          <Route path="/datacapture" element={<DataCapture />} />
          {/* <Route path="/imagecapture" element={<ImageCapture />} /> */}
      </Routes>    
    </UserProvider>
  </BrowserRouter>
  );
}

export default App;
